/// <reference lib="dom" />
// imports dom lib for tsc for backend for this specific file
import firebase from "firebase/app";
import { LanguageCode } from "types/language";

export enum TokenStatus {
  Granted = "GRANTED",
  Denied = "DENIED",
  SignedOut = "SIGNED_OUT",
  DeviceNotRegistered = "DEVICE_NOT_REGISTERED",
}

export type TokenEntry = {
  experienceId: string;
  lastUpdateDate: any;
  platform: "ios" | "android" | "windows" | "macos" | "web"; // don't use typeof Platform since we import on backend
} & (
  | {
      status: TokenStatus.Denied;
      token?: string;
    }
  | { status: TokenStatus.SignedOut; token?: string }
  | { status: TokenStatus.DeviceNotRegistered; token?: string }
  | {
      status: TokenStatus.Granted;
      token: string;
    }
);

export type TokensMap = {
  [installationId: string]: TokenEntry;
};

export type FirestoreUserData = {
  tokens?: TokensMap;
  wantShowAsFriendOfFriends: boolean;
  habitOrdering: string[];
  photoURL: string;
  displayName: string;
  language?: LanguageCode;
  // TODO: At some point, these fields should be migrated to a read only doc;
  // user should not be able to write these fields
  isSignedUp: boolean;
  handle: string;
  data?: object;
  organizationId?: string;
};

export type User = firebase.User & FirestoreUserData;
